import tw from 'twin.macro'

export const Container = tw.div`
  max-w-screen-xl
  mx-auto
  px-4
`
export const ContainerFluid = tw.div`
`
